module.exports = __webpack_public_path__ + "2b8be919c85b728754cda8677b80bc26.jpg";